import { IonIcon, IonLabel } from '@ionic/react'
import { chevronForward, lockClosedOutline, logInOutline, trashOutline } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useUser from '../../../contexts/hooks/useUser'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import ProfileInformationCard from '../components/ProfileInformationCard'

const AccountManagement = () => {
	const { t } = useTranslation('pages_settings', { keyPrefix: 'accountManagement' })
	const history = useHistory()

	const { isCustomer } = useUser()

	return (
		<PageWrapper page='accountManagement' appBarOptions={{ backPath: '/settings' }}>
			<div className='flex flex-col gap-6'>
				<div className='flex flex-col gap-2'>
					<p className='text-xs font-semibold uppercase tracking-widest text-text-grey-200/50 dark:text-white/40 px-1'>
						{t('loginSection')}
					</p>
					<ProfileInformationCard
						icon={lockClosedOutline}
						label={t('changePassword')}
						page='settings/account-management/change-password'
					/>
				</div>

				<div className='flex flex-col gap-2'>
					<p className='text-xs font-semibold uppercase tracking-widest text-text-grey-200/50 dark:text-white/40 px-1'>
						{t('infoSection')}
					</p>
					{!isCustomer && (
						<ProfileInformationCard
							icon={logInOutline}
							label={t('authorizations')}
							page='settings/authorizations'
						/>
					)}
				</div>

				<div className='flex flex-col gap-2'>
					<p className='text-xs font-semibold uppercase tracking-widest text-red-400/70 px-1'>
						{t('dangerSection')}
					</p>
					<div
						onClick={() => history.push('/settings/account-management/delete-account')}
						className='flex flex-row items-center justify-between rounded-xl py-6 px-8 shadow-md group hover bg-white dark:bg-brand-secondary-200-dark'
					>
						<div className='flex flex-row items-center gap-6'>
							<IonIcon className='text-[1.4rem] text-red-500' icon={trashOutline} />
							<IonLabel className='text-red-500 font-medium'>{t('deleteAccount')}</IonLabel>
						</div>
						<IonIcon
							className='text-[2.15rem] text-red-300 transition-transform group-hover:scale-[1.2] group-hover:transition-transform'
							icon={chevronForward}
						/>
					</div>
				</div>
			</div>
		</PageWrapper>
	)
}

export default AccountManagement
